import { cn } from '@shared/lib/cn';

export interface CheckboxSkeletonProps {
  className?: string;
}

/** Checkbox 의 status=init — 상자 20 + 글자 막대 80×12 */
export function CheckboxSkeleton({ className }: CheckboxSkeletonProps) {
  return (
    <span
      aria-hidden="true"
      data-status="init"
      className={cn('skeleton-pulse', 'inline-flex items-center gap-1', className)}
    >
      <span className="size-5 rounded-sm bg-bg-pressed" />
      <span className="h-3 w-20 rounded-full bg-bg-pressed" />
    </span>
  );
}
